<template>
  <div>
    <div class="video">
      <img src="@/assets/cdk_header.png" class="cdk_header" />
      <div class="from_bg">
        <div class="from">
          <div class="title">
            <div class="title_bg"></div>
            <div class="title_txt">填写兑换信息</div>
          </div>
          <div class="message" style="padding: 12px">
            <div style="text-align: center">
              <el-form :label-position="top" :model="formLabelAlign">
                <el-form-item>
                  <el-input v-model="carmi" placeholder="请输入兑换码/卡密" style="width: 90%" />
                </el-form-item>

                <div style="text-align: center">
                  <el-button type="warning" round style="width: 90%" @click="queryConvert()" v-preventClick>
                    查询兑换商品
                  </el-button>
                </div>

                <div v-if="paramForm">
                  <el-divider>确认信息 完成充值</el-divider>

                  <div style="padding: 0px 15px">
                    <el-form-item label="兑换商品">
                      <el-input v-model="paramForm.productName" :disabled="true" />
                    </el-form-item>

                    <el-form-item>
                      <orderParam :orderParams="paramForm.orderParams" v-model="paramForm.orderParams">
                      </orderParam>
                    </el-form-item>
                  </div>

                  <div style="text-align: center">
                    <el-button type="success" round style="width: 90%" @click="confirm" v-preventClick>
                      立即兑换
                    </el-button>
                  </div>
                </div>
              </el-form>
            </div>
            <div style="text-align: center; margin-top: 15px">
              <el-button type="text" @click="progressQuery" v-preventClick>兑换进度查询</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="rules_bg">
        <div class="rules">
          <div class="title">
            <div class="title_bg"></div>
            <div class="title_txt">兑换规则</div>
          </div>
          <div class="rules_list">
            <div>
              <p>（1）</p>
              <p>在【券码/卡密】直接粘贴收到的券码或卡密；</p>
            </div>
            <div>
              <p>（2）</p>
              <p>输入需要兑换的账号，点击【立即兑换】即可；</p>
            </div>
          </div>
          <div class="title reminder_title">
            <div class="title_bg"></div>
            <div class="title_txt">温馨提示</div>
          </div>
          <div class="rules_list reminder_list">
            <div>
              <p>（1）</p>
              <p>请务必填写正确的账号；</p>
            </div>
            <div>
              <p>（2）</p>
              <p>此为虚拟直充商品，兑换成功后，不支持退换，敬请谅解；</p>
            </div>
            <div>
              <p>（3）</p>
              <p>
                此商品是系统自动兑换，以下单填写的信息为准，不能更改，如因买家填写错误造成的损失，需买家
                自行承担，敬请谅解；
              </p>
            </div>
            <div>
              <p>（4）</p>
              <p>有疑问请联系客服咨询</p>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="link">
        <a
          href="http://wpa.qq.com/msgrd?v=3&amp;uin=427950153&amp;site=qq&amp;menu=yes"
          class="link_btn"
          ><img
            src="data:image/png;base64,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"
            alt=""
            class="link_icon"
          /><span class="link_text">在线客服</span></a
        ><a href="tel:400 9900 090" class="link_btn"
          ><img
            src="data:image/png;base64,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"
            alt=""
            class="link_icon"
          />
          <div class="link_texts">
            <span class="link_texts_top">权益热线</span
            ><span class="link_texts_bottom">400 9900 090</span>
          </div></a
        >
      </div> -->
      <!----><!---->
    </div>

    <!-- 查询兑换记录 -->
    <van-popup v-model="dialogVisible" round position="bottom" :style="{ height: '90%' }">
      <div style="padding: 40px 20px;">
        <el-form>
          <el-form-item>
            <el-input v-model="cdkForm.cdkey" placeholder="请输入兑换码/卡密"></el-input>
          </el-form-item>

          <template v-if="orderDetails">
            <el-form-item label="兑换商品">
              <el-input v-model="orderDetails.productName" :disabled="true" />
            </el-form-item>

            <el-form-item label="兑换时间">
              <el-input v-model="orderDetails.usagTime" :disabled="true" />
            </el-form-item>

            <el-form-item label="充值状态">
              <el-input v-model="orderDetails.statusDelivery" :disabled="true" />
            </el-form-item>

            <van-divider>充值账号</van-divider>

            <div  v-for="(item, index) in orderDetails.orderParams" :key="index">
              <el-form-item :label="item.name">
                <el-input v-model="item.value" :disabled="true" />
              </el-form-item>
            </div>


          </template>
        </el-form>

        <div style="padding:10px">
          <van-button type="primary" block round @click="queryOrder">立即查询</van-button>
        </div>

        <div style="padding:10px">
          <van-button block round @click="dialogVisible = false">关闭</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { queryConvertProduct, confirmConvert, queryConvertLog } from "../api/cdkey";
import { Toast } from "vant";
import orderParam from "@/components/orderParam.vue";

export default {
  components: {
    orderParam,
  },
  data() {
    return {
      orderDetails: undefined,
      cdkForm: {
        cdkey: undefined,
      },
      dialogVisible: false,
      paramForm: undefined,
      carmi: undefined,
    };
  },
  created() {
    document.title = "权益兑换中心";
  },
  methods: {
    /**
     * 查询权益商品
     */
    queryConvert() {
      if (!this.carmi) {
        Toast("请输入兑换码");

        return;
      }

      let data = {
        carmi: this.carmi,
      };
      queryConvertProduct(data).then((response) => {
        if (response.status == 0) {
          this.paramForm = response.result.data;
        }
      });
    },
    // /**
    //  * 兑换卡密
    //  */
    // cashCdkey() {
    //   console.log(this.queryParam.cdkey);
    //   if (this.queryParam.cdkey == undefined) {
    //     Toast("请输入兑换码");
    //     return;
    //   }
    //   if (this.queryParam.rechargeAccount == undefined) {
    //     Toast("请输入充值账号");
    //     return;
    //   }
    //   this.confirmStatus = true;
    // },

    /**
     * 确认兑换
     */
    confirm() {
      Toast.loading({
        message: "兑换中",
        forbidClick: true,
      });
      confirmConvert(this.paramForm).then((response) => {
        if (response.status == 0) {
          Toast.success(response.result);
          this.paramForm = undefined;
        }
      });
    },

    /**
     * 兑换进度弹框
     */
    progressQuery() {
      this.cdkForm.cdkey = undefined;
      this.orderDetails = undefined;
      this.dialogVisible = true;
    },

    /**
     * 立即查询
     */
    queryOrder() {
      queryConvertLog(this.cdkForm).then((response) => {
        if (response.status == 0) {
          this.orderDetails = response.result
        }
      });
    },
  },
};
</script>
<style scoped>
.video {
  background: #5b46ef;
}

.video .cdk_header {
  width: 100vw;
  height: 62.267vw;
}

.video .from_bg {
  margin: 0 auto;
  width: 96.933vw;
  background: rgba(137, 199, 252, 0.3);
  border-radius: 1.333vw;
  padding-top: 1.467vw;
  padding-bottom: 2.133vw;
  content: "viewport-units-buggyfill; width: 96.933vw; border-radius: 1.333vw; padding-top: 1.467vw; padding-bottom: 2.133vw";
}

.video .from_bg .from {
  margin: 0 auto;
  width: 94vw;
  background: #fff;
  border-radius: 1.333vw;
  padding-bottom: 5.067vw;
  content: "viewport-units-buggyfill; width: 94vw; border-radius: 1.333vw; padding-bottom: 5.067vw";
}

.video .from_bg .from .title {
  position: relative;
  padding-left: 30vw;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  top: 4.267vw;
  height: 16vw;
  content: "viewport-units-buggyfill; padding-left: 30vw; top: 4.267vw; height: 16vw";
}

.video .from_bg .from .title .title_bg {
  position: absolute;
  width: 34vw;
  height: 3.333vw;
  background: #dfe9ff;
  top: 3.333vw;
  content: "viewport-units-buggyfill; width: 34vw; height: 3.333vw; top: 3.333vw";
}

.video .from_bg .from .title .title_txt {
  position: absolute;
  left: 32.667vw;
  font-size: 4.8vw;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  font-weight: 700;
  color: #4570eb;

  content: "viewport-units-buggyfill; left: 32.667vw; font-size: 4.8vw";
}

.video .from_bg .message .input {
  position: relative;
}

.video .from_bg .message .input .tips {
  width: 74.267vw;
  height: 13.067vw;
  background: #eff6ff;
  border-radius: 1.333vw;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 2.133vw 1.333vw 1.333vw 4.4vw;
  margin-left: 9.867vw;
  font-size: 3.467vw;
  font-family: Hiragino Sans GB;
  font-weight: 400;
  color: #ff9727;
  text-align: left;
  content: "viewport-units-buggyfill; width: 74.267vw; height: 13.067vw; border-radius: 1.333vw; padding: 2.133vw 1.333vw 1.333vw 4.4vw; margin-left: 9.867vw; font-size: 3.467vw";
}

.video .from_bg .message .input .code {
  width: 5.333vw;
  height: 5.2vw;
  position: absolute;
  left: 11.867vw;
  top: 5.867vw;
  padding-right: 3.867vw;
  border-right: 0.267vw solid #618ef1;
  content: "viewport-units-buggyfill; width: 5.333vw; height: 5.2vw; left: 11.867vw; top: 5.867vw; padding-right: 3.867vw; border-right: 0.267vw solid #618ef1";
}

.video .from_bg .message .input .number {
  top: 5.733vw;
  left: 12.533vw;
  padding-right: 3.467vw;
  width: 5.2vw;
  height: 5.867vw;
  content: "viewport-units-buggyfill; top: 5.733vw; left: 12.533vw; padding-right: 3.467vw; width: 5.2vw; height: 5.867vw";
}

.video .from_bg .message .input .verification_code {
  width: 4.667vw;
  height: 5.867vw;
  left: 12.533vw;
  content: "viewport-units-buggyfill; width: 4.667vw; height: 5.867vw; left: 12.533vw";
}

.video .from_bg .message .input .form_code {
  margin-top: 2.4vw;
  margin-bottom: 2vw;
  width: 81.067vw;
  height: 12.8vw;
  border-radius: 6.933vw;
  font-size: 4.267vw;
  outline: none;
  padding-left: 18.667vw;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 0.267vw;
  border: 0.267vw solid #618ef1;
  -webkit-appearance: none;
  content: "viewport-units-buggyfill; margin-top: 2.4vw; margin-bottom: 2vw; width: 81.067vw; height: 12.8vw; border-radius: 6.933vw; font-size: 4.267vw; padding-left: 18.667vw; padding-top: 0.267vw; border: 0.267vw solid #618ef1";
}

.video .from_bg .message .input .form_code::-webkit-input-placeholder {
  color: #b9b9b9;
}

.video .from_bg .message .input .form_code::-moz-placeholder {
  color: #b9b9b9;
}

.video .from_bg .message .input .form_code::-ms-input-placeholder {
  color: #b9b9b9;
}

.video .from_bg .message .input .form_code::placeholder {
  color: #b9b9b9;
}

.video .from_bg .message .input .verification {
  width: 48vw;
  margin-left: -33.867vw;
  content: "viewport-units-buggyfill; width: 48vw; margin-left: -33.867vw";
}

.video .from_bg .message .input .card_img {
  position: absolute;
  width: 29.467vw;
  height: 13.333vw;
  top: 2vw;
  right: 7.333vw;
  content: "viewport-units-buggyfill; width: 29.467vw; height: 13.333vw; top: 2vw; right: 7.333vw";
}

.video .from_bg .detail {
  margin: 6vw auto 0;
  width: 32.933vw;
  height: 6.8vw;
  line-height: 6.8vw;
  border: 0.267vw solid #f7a44a;
  border-radius: 3.467vw;
  font-size: 4.267vw;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #f7a44a;
  content: "viewport-units-buggyfill; margin-top: 6vw; width: 32.933vw; height: 6.8vw; line-height: 6.8vw; border: 0.267vw solid #f7a44a; border-radius: 3.467vw; font-size: 4.267vw";
}

.video .rules_bg {
  margin: 2.8vw auto 0;
  width: 96.933vw;
  background: rgba(137, 199, 252, 0.3);
  padding-top: 1.733vw;
  padding-bottom: 2.4vw;
  content: "viewport-units-buggyfill; margin-top: 2.8vw; width: 96.933vw; border-radius: 1.333vw; padding-top: 1.733vw; padding-bottom: 2.4vw";
}

.video .rules_bg .rules,
.video .rules_bg {
  border-radius: 1.333vw;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.video .rules_bg .rules {
  margin: 0 auto;
  width: 94vw;
  background: #fff;
  padding-bottom: 2.933vw;
  content: "viewport-units-buggyfill; width: 94vw; padding-bottom: 2.933vw; border-radius: 1.333vw";
}

.video .rules_bg .rules .title {
  position: relative;
  padding-left: 35.867vw;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  top: 4.8vw;
  height: 16vw;
  content: "viewport-units-buggyfill; padding-left: 35.867vw; top: 4.8vw; height: 16vw";
}

.video .rules_bg .rules .title .title_bg {
  position: absolute;
  width: 22.267vw;
  height: 3.333vw;
  background: #dfe9ff;
  top: 3.333vw;
  content: "viewport-units-buggyfill; width: 22.267vw; height: 3.333vw; top: 3.333vw";
}

.video .rules_bg .rules .title .title_txt {
  position: absolute;
  left: 37.333vw;
  font-size: 4.8vw;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  font-weight: 700;
  color: #4570eb;
  content: "viewport-units-buggyfill; left: 37.333vw; font-size: 4.8vw";
}

.video .rules_bg .rules .reminder_title {
  top: 4vw;
  content: "viewport-units-buggyfill; top: 4vw";
}

.video .rules_bg .rules .rules_list {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 2vw 5.6vw 0;
  content: "viewport-units-buggyfill; padding: 2vw 5.6vw 0px 5.6vw";
}

.video .rules_bg .rules .rules_list div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.video .rules_bg .rules .rules_list p {
  /* font-size: 3.2vw; */
  /* font-family: Source Han Sans CN; */
  font-weight: 500;
  color: #333;
  text-align: left;
  margin-bottom: 2.8vw;
}

.video .rules_bg .rules .reminder_list {
  padding-top: 0;
}

.video .link {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 4vw 18.267vw 6.667vw;
  position: relative;
  content: "viewport-units-buggyfill; padding: 4vw 18.267vw 6.667vw 18.267vw";
}

.video .link .link_btn,
.video .link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.video .link .link_btn {
  border: none;
  width: 29.333vw;
  height: 11.733vw;
  background: linear-gradient(0deg, #3c9bf3, #3fb3ff);
  border-radius: 5.867vw;
  text-decoration: none;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  content: "viewport-units-buggyfill; width: 29.333vw; height: 11.733vw; border-radius: 5.867vw";
}

.video .link .link_btn .link_icon {
  width: 6.133vw;
  height: 6.133vw;
  margin-right: 0.667vw;
  content: "viewport-units-buggyfill; width: 6.133vw; height: 6.133vw; margin-right: 0.667vw";
}

.video .link .link_btn .link_text,
.video .link .link_btn .link_texts .link_texts_top {
  font-size: 4vw;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  content: "viewport-units-buggyfill; font-size: 4vw";
}

.video .link .link_btn .link_texts .link_texts_top {
  display: block;
}

.video .link .link_btn .link_texts .link_texts_bottom {
  display: block;
  font-size: 2.533vw;
  font-family: Mont;
  color: #fff;
  content: "viewport-units-buggyfill; font-size: 2.533vw";
}

.video .mask {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.video .mask_coent {
  position: fixed;
  z-index: 2;
  width: 88.8vw;
  height: 64.8vw;
  background: #fff;
  border-radius: 2.667vw;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  content: "viewport-units-buggyfill; width: 88.8vw; height: 64.8vw; border-radius: 2.667vw";
}

.video .mask_coent p {
  height: 16.267vw;
  line-height: 16.267vw;
  background: #089efd;
  border-radius: 2.667vw 2.667vw 0 0;
  font-size: 4.267vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  content: "viewport-units-buggyfill; height: 16.267vw; line-height: 16.267vw; border-radius: 2.667vw 2.667vw 0px 0px; font-size: 4.267vw";
}

.video .mask_coent .input {
  position: relative;
  top: 5.333vw;
  content: "viewport-units-buggyfill; top: 5.333vw";
}

.video .mask_coent .input .code {
  width: 5.333vw;
  height: 5.2vw;
  position: absolute;
  left: 11.467vw;
  top: 5.867vw;
  padding-right: 3.867vw;
  border-right: 0.267vw solid #618ef1;
  content: "viewport-units-buggyfill; width: 5.333vw; height: 5.2vw; left: 11.467vw; top: 5.867vw; padding-right: 3.867vw; border-right: 0.267vw solid #618ef1";
}

.video .mask_coent .input .form_code {
  margin-top: 2.4vw;
  margin-bottom: 2vw;
  width: 81.067vw;
  height: 12.8vw;
  border-radius: 6.933vw;
  outline: none;
  padding-left: 18.667vw;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 0.267vw solid #618ef1;
  content: "viewport-units-buggyfill; margin-top: 2.4vw; margin-bottom: 2vw; width: 81.067vw; height: 12.8vw; border-radius: 6.933vw; padding-left: 18.667vw; border: 0.267vw solid #618ef1";
}

.video .mask_coent .input .form_code::-webkit-input-placeholder {
  color: #b9b9b9;
}

.video .mask_coent .input .form_code::-moz-placeholder {
  color: #b9b9b9;
}

.video .mask_coent .input .form_code::-ms-input-placeholder {
  color: #b9b9b9;
}

.video .mask_coent .input .form_code::placeholder {
  color: #b9b9b9;
}

.video .mask_coent .input .verification {
  width: 47.467vw;
  margin-left: -33.867vw;
  content: "viewport-units-buggyfill; width: 47.467vw; margin-left: -33.867vw";
}

.video .mask_coent .input .card_img {
  position: absolute;
  width: 29.467vw;
  height: 13.333vw;
  top: 2vw;
  right: 7.333vw;
  content: "viewport-units-buggyfill; width: 29.467vw; height: 13.333vw; top: 2vw; right: 7.333vw";
}

.video .mask_coent .mask_btn {
  width: 81.067vw;
  font-size: 4.267vw;
  margin: 9.333vw auto 0;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #fff;
  height: 13.867vw;
  line-height: 13.867vw;
  background: linear-gradient(0deg, #3c9bf3, #3fb3ff);
  border-radius: 6.933vw;
  content: "viewport-units-buggyfill; width: 81.067vw; font-size: 4.267vw; margin-top: 9.333vw; height: 13.867vw; line-height: 13.867vw; border-radius: 6.933vw";
}
</style>
